import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { FormHelperText } from '@material-ui/core';
import {
  KeyboardDateTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
// import { setDate } from 'date-fns';
import { isEmpty, isNull } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

export default function DateTimeGrid({
  time,
  onSubmit,
  initials,
  id,
  type,
  keySubmit,
}) {
  const [data, setData] = React.useState(null);
  const [valueDate, setValueDate] = useState('');
  const [datePicker, setDatePicker] = useState('');

  const { language } = useSelector((state) => state.user);

  // Modify format date and time component
  const formatDateTime = React.useMemo(() => {
    if (language === 'pt-BR') {
      if (time) return 'DD/MM/YYYY HH:mm:ss';

      return 'DD/MM/YYYY';
    }

    if (time) return 'YYYY-MM-DD HH:mm:ss';

    return 'YYYY-MM-DD';
  }, [language, time]);

  // Change date time
  const handleChangeData = React.useCallback((value) => {
    if (!isNull(value) && value._isValid) {
      setData(value);
      setValueDate(value.format(formatDateTime));
    } else {
      setData(null);
      setValueDate(null);

      onSubmit(id, type, '');
    }
  }, []);

  const handleKey = useCallback((keyValue) => {
    if (keyValue === 'Enter') {
      keySubmit(keyValue);
    }
  }, []);

  React.useEffect(() => {
    setData(initials || moment());
    setValueDate(
      moment(initials).format(formatDateTime) || moment().format(formatDateTime)
    );
  }, [initials]);

  useEffect(() => {
    if (data) {
      onSubmit(id, type, valueDate);
    }
  }, [data, valueDate]);

  useEffect(() => {
    if (!isEmpty(datePicker)) {
      keySubmit('Enter');
    }
  }, [datePicker]);

  if (time)
    return (
      <KeyboardDateTimePicker
        fullWidth
        ampm={false}
        value={data}
        onChange={handleChangeData}
        format={formatDateTime}
        onAccept={(value) => {
          onSubmit(id, type, value.format(formatDateTime));
          setDatePicker(value);
        }}
        onKeyUp={({ key }) => handleKey(key)}
      />
    );

  return (
    <KeyboardDatePicker
      fullWidth
      value={data}
      onChange={handleChangeData}
      format={formatDateTime}
      onKeyUp={({ key }) => handleKey(key)}
    />
  );
}

DateTimeGrid.propTypes = {
  time: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  initials: PropTypes.string,
  id: PropTypes.oneOfType(PropTypes.string, PropTypes.number).isRequired,
  type: PropTypes.string.isRequired,
};

DateTimeGrid.defaultProps = {
  time: false,
  initials: '',
};
